import { selectDoesUserHaveRbacPermission } from 'core/userContext/selectors';
import { PLACEMENT_DISPLAY_CONTENT } from 'modules/placements/constants';
import { useSelector } from 'react-redux';
import { PrimaryButton, SecondaryButton } from 'ui/button';
import { Add16, Folder } from 'ui/icons';
import { PROJECT_PERMISSIONS } from 'utils/permissions';
import {
  ButtonsWrapper,
  PlacementPromptContainer,
  PlacementPromptContent,
  SecondaryText,
  StyledIllustration,
  StyledLink,
} from './styles';

const {
  createPlacementsPrompt: {
    createPlacementButtonLabel,
    createPlacementInstructionsLabel,
    learnMoreButtonLabel,
    noPlacementsInAccountDocumentationPath,
  },
  managePlacementsPath,
} = PLACEMENT_DISPLAY_CONTENT;

export const CreatePlacementsPrompt = () => {
  const canViewPlacements = useSelector(selectDoesUserHaveRbacPermission)(
    PROJECT_PERMISSIONS.ViewChannelConfiguration,
  );
  return (
    <PlacementPromptContainer data-test="create-placements-prompt">
      <PlacementPromptContent>
        <SecondaryText>{createPlacementInstructionsLabel}</SecondaryText>
        <ButtonsWrapper>
          <StyledLink
            data-test="manage-placements-link"
            href={canViewPlacements ? managePlacementsPath : undefined}
          >
            <PrimaryButton isDisabled={!canViewPlacements}>
              <Add16 />
              <span>{createPlacementButtonLabel}</span>
            </PrimaryButton>
          </StyledLink>
          <StyledLink
            data-test="placements-learn-more-link"
            href={noPlacementsInAccountDocumentationPath}
            target="_blank"
          >
            <SecondaryButton>
              <Folder />
              <span>{learnMoreButtonLabel}</span>
            </SecondaryButton>
          </StyledLink>
        </ButtonsWrapper>
      </PlacementPromptContent>
      <StyledIllustration />
    </PlacementPromptContainer>
  );
};
